import LocalizedStrings from 'react-localization';

export const translations = new LocalizedStrings({
  en: {
    translation: {
      downloadButton: 'Download Document',
      searchPlaceholder: 'Search in this publication',
      page: 'Page',
      of: 'of',
      matches: 'Results',
      download: 'Download',
      previewErrorMessage: 'This preview is currently unavailable. Please click on Download to access the publication',
      generatingPreview: 'Generating Preview....',
      loadingMessage: 'Loading Dataset....',
      'seek.panel_title': 'Converse with IDB Datasets',
      'seek.ask_question': 'Ask this dataset a question:',
      'seek.ask_global_question': 'Ask a question:',
      'seek.try_suggestions_heading': 'Try one of these options:',
      'seek.action.new_chat': 'New Chat',
      'seek.action.summarize': 'Overview',
      'seek.placeholders': ['What is...', 'How does...', 'What are...', 'Overview of ...'],
      'seek.awaiting_response': 'Awaiting response...',
      'seek.loadingMessages': [
        'Putting on my detective hat and scouring the document for clues to solve the mystery!', 
        'Rummaging through the archives to unravel the mysteries of the universe...just a few more moments!', 
        'Digging through the digital haystack, to find the needle of knowledge you seek!', 
        'Roses are red, violets are blue, searching for answers, just for you!',
        'Please wait, response is being generated...'
      ],
      'seek.help.heading': 'Seek is a generative AI tool to help you explore the contents of IDB Datasets. If you have questions about other things, please use a different tool.',
      'seek.help.heading2': 'Seek is designed to:',
      'seek.help.points': [
        'Give you a summary of a dataset: Press the Document Summary button, or ask seek to "Summarize this dataset."',
        'Answer your specific questions about the dataset\'s contents: Select one of the options provided, or ask you own question about the research findings and main points.'
      ],
      'seek.help.disclaimer': 'Seek can make mistakes. Be sure to verify the response with information in the publication',
      'seek.summary_question': "Give me an overview of this dataset.",
      'seek.error.question_limit': 'Wow!  What curiosity!  You\'ve reached the maximum number of questions for seek at this time. Try again in a few hours.',
      'global_seek.placeholder': 'Ask a question across peer-reviewed datasets',
      'global_seek.advanced_search': 'Advanced Search',
      'keyword.placeholder': 'Keyword Search across all publications',
      'seek.suggestions': [
        'Give me an overview of this dataset.',
        'What is the geographical coverage of this dataset?',
        'What are the variables/indicators of the dataset?',
        'What is the temporal coverage of this dataset?',
      ],
      'seek.cot.thought': 'Thought',
      'seek.cot.unknown': 'Unknown',
      'seek.cot.tool_named': 'Tool: {0}',
      'seek.cot.result': 'Result',
      'seek.cot.result_named': 'Result: {0}',
      'seek.cot.thinking': 'Thinking...',
      'seek.cot.chain_of_thought': 'Chain of Thought',
      'seek.cot.steps': '{0} steps',
      'seek.cot.status.starting': 'Reading your question...',
      'seek.cot.status.analysing': 'Working through the numbers...',
      'seek.cot.status.still_working': 'Still working on this — this one is taking a little longer.',
      'seek.copy_response': 'Copy Response',
      'seek.copied': 'Copied',
      'seek.generative_ai': 'Generative AI',
      'seek.answer_derived_from_resources': 'The answer was derived from these resources:',
    }
  },
  es: {
    translation: {
      downloadButton: 'Descargar Documento',
      searchPlaceholder: 'Buscar dentro de esta publicación',
      page: 'Página',
      of: 'de',
      matches: 'Resultados',
      download: 'Descargar',
      previewErrorMessage: 'En este momento no es posible visualizar la publicación. Para acceder al documento presione Descargar',
      generatingPreview: 'Cargando vista previa....',
      loadingMessage: 'Cargando Publicación....',
      'seek.panel_title': 'Conversar con publicaciones del BID revisadas por pares',
      'seek.ask_question': 'Hazle una pregunta a este conjunto de datos:',
      'seek.ask_global_question': 'Haz una pregunta:',
      'seek.try_suggestions_heading': 'Prueba una de estas opciones:',
      'seek.action.new_chat': 'Nuevo chat',
      'seek.action.summarize': 'Descripción general',
      'seek.placeholders': ['Qué es...', 'Cómo...', 'Cuáles son...', 'Descripción general de ...'],
      'seek.awaiting_response': 'Awaiting response...',
      'seek.loadingMessages': [
        '¡Poniéndome mi sombrero de detective y examinando el documento en busca de pistas para resolver el misterio!', 
        'Escarbando en los archivos para desentrañar los misterios del universo... ¡Solo un momento más!', 
        '¡Explorando el pajar digital en busca de la aguja del conocimiento que necesitas!', 
        '¡Rojo es el rubí, azul el zafiro, buscando respuestas en un suspiro!',
        'Por favor espera, la respuesta se está generando...'
      ],
      'seek.help.heading': 'Seek es una herramienta de inteligencia artificial generativa para ayudarte a explorar el contenido de las publicaciones del BID. Si tienes preguntas sobre otros temas, por favor utiliza una herramienta diferente.',
      'seek.help.heading2': 'Seek está diseñada para:',
      'seek.help.points': [
        'Darte un resumen de una publicación: Oprime el botón de Resumen del documento o pídele a Seek que te "Resuma la publicación"',
        'Responder a tus preguntas especfícas sobre el contenido de la publicación: Selecciona una de las opciones proporcionadas o haz tu propia pregunta sobre los hallazgos de la investigación y los puntos principales.',
      ],
      'seek.help.disclaimer': 'Seek puede cometer errores. Asegúrate de verificar la respuesta con la información en la publicación.',
      'seek.summary_question': "Resuma la publicación",
      'seek.error.question_limit': '¡Guau! ¡Qué curiosidad! Has alcanzado el número máximo de preguntas permitidas en este momento. Intenta nuevamente en unas horas.',
      'global_seek.placeholder': 'Haz una pregunta en las publicaciones revisadas por pares',
      'global_seek.advanced_search': 'Búsqueda Avanzada',
      'keyword.placeholder': 'Buscar por palabra clave en todas las publicaciones',
      'seek.suggestions': [
        'Dame un resumen de este conjunto de datos.',
        '¿Cuál es la cobertura geográfica de este conjunto de datos?',
        '¿Cuáles son las variables/indicadores del conjunto de datos?',
        '¿Cuál es la cobertura temporal de este conjunto de datos?',
      ],
      'seek.cot.thought': 'Razonamiento',
      'seek.cot.unknown': 'Desconocido',
      'seek.cot.tool_named': 'Herramienta: {0}',
      'seek.cot.result': 'Resultado',
      'seek.cot.result_named': 'Resultado: {0}',
      'seek.cot.thinking': 'Pensando...',
      'seek.cot.chain_of_thought': 'Cadena de razonamiento',
      'seek.cot.steps': '{0} pasos',
      'seek.cot.status.starting': 'Leyendo tu pregunta...',
      'seek.cot.status.analysing': 'Analizando las cifras...',
      'seek.cot.status.still_working': 'Seguimos trabajando en esto: está tardando un poco más.',
      'seek.copy_response': 'Copiar respuesta',
      'seek.copied': 'Copiado',
      'seek.generative_ai': 'IA Generativa',
      'seek.answer_derived_from_resources': 'La respuesta se obtuvo a partir de estos recursos:',
    }
  },
  pt: {
    translation: {
      downloadButton: 'Baixar Documento',
      searchPlaceholder: 'Pesquisar dentro desta publicação',
      page: 'Página',
      of: 'de',
      matches: 'Resultados',
      download: 'Baixar',
      previewErrorMessage: 'Neste momento não é possível visualizar a publicação. Para acessar o documento pressione Baixar',
      generatingPreview: 'Gerando visualização previa....',
      loadingMessage: 'Carregando Publicação....',
      'seek.panel_title': 'Converse com publicações do BID revisadas por pares',
      'seek.ask_question': 'Faça uma pergunta a este conjunto de dados:',
      'seek.ask_global_question': 'Faça uma pergunta:',
      'seek.try_suggestions_heading': 'Experimente uma destas opções:',
      'seek.action.new_chat': 'Novo chat',
      'seek.action.summarize': 'Visão geral',
      'seek.placeholders': ['O que é...', 'Como é que...', 'Quais são...', 'Visão geral de ...'],
      'seek.awaiting_response': 'Awaiting response...',
      'seek.loadingMessages': [
        'Colocando meu chapéu de detetive e buscando por pistas no documento para solucionar o mistério!', 
        'Buscando nos arquivos para desvendar os mistérios do universo... só mais alguns minutos.', 
        'Cavando no palheiro digital para buscar a agulha do conhecimento que você procura.', 
        'Rosas são vermelhas, violetas são azuis, buscando uma resposta na velocidade da luz!',
        'Por favor aguarde, a resposta está sendo gerada...'
      ],
      'seek.help.heading': 'Seek é uma ferramenta de inteligência artificial generativa para te ajudar a explorar os conteúdos das publicações do BID. Se você tem perguntas sobre outros temas, favor utilizar outra ferramenta.',
      'seek.help.heading2': 'Seek está projetado para:',
      'seek.help.points': [
        'Fornecer um resumo de uma publicação: Pressione o botão resumo do documento, ou solicite a Seek "Resumir esta publicação"',
        'Responda às suas perguntas específicas sobre o conteúdo da publicação: Selecione uma das opções fornecidas, ou faça sua própria pergunta sobre os resultados da pesquisa e os pontos principais.',
      ],
      'seek.help.disclaimer': 'Seek pode cometer erros. Certifique-se de verificar a resposta com as informações da publicação.',
      'seek.summary_question': "Resumir esta publicação",
      'seek.error.question_limit': 'Uau! Que curiosidade! Você atingiu o número máximo de perguntas para o Seek neste momento. Tente novamente em algumas horas.',
      'global_seek.placeholder': 'Faça uma pergunta à todas as publicações revisadas por pares',
      'global_seek.advanced_search': 'Pesquisa Avançada',
      'keyword.placeholder': 'Buscar por palavras-chave em todas as publicações',
      'seek.suggestions': [
        'Me dê uma visão geral deste conjunto de dados.',
        'Qual é a cobertura geográfica deste conjunto de dados?',
        'Quais são as variáveis/indicadores do conjunto de dados?',
        'Qual é a cobertura temporal deste conjunto de dados?',
      ],
      'seek.cot.thought': 'Raciocínio',
      'seek.cot.unknown': 'Desconhecido',
      'seek.cot.tool_named': 'Ferramenta: {0}',
      'seek.cot.result': 'Resultado',
      'seek.cot.result_named': 'Resultado: {0}',
      'seek.cot.thinking': 'Pensando...',
      'seek.cot.chain_of_thought': 'Cadeia de raciocínio',
      'seek.cot.steps': '{0} passos',
      'seek.cot.status.starting': 'Lendo a sua pergunta...',
      'seek.cot.status.analysing': 'Analisando os números...',
      'seek.cot.status.still_working': 'Ainda trabalhando nisto: está demorando um pouco mais.',
      'seek.copy_response': 'Copiar resposta',
      'seek.copied': 'Copiado',
      'seek.generative_ai': 'IA Generativa',
      'seek.answer_derived_from_resources': 'A resposta foi obtida a partir destes recursos:',
    }
  },
  fr: {
    translation: {
      downloadButton: 'Download Document',
      searchPlaceholder: 'Search in this publication',
      page: 'Page',
      of: 'of',
      matches: 'Matches',
      download: 'Télécharger',
      previewErrorMessage: 'Cet aperçu est actuellement indisponible. Veuillez cliquer sur télécharger pour accéder à la publication',
      generatingPreview: 'Génération de l’ aperçu....',
      loadingMessage: 'Chargement de la publication en cours....',
      'seek.panel_title': 'Discutez avec les publications',
      'seek.ask_question': 'Posez une question à ce jeu de données :',
      'seek.ask_global_question': 'Posez une question:',
      'seek.try_suggestions_heading': 'Try one of these options:',
      'seek.action.new_chat': 'Nouveau chat',
      'seek.action.summarize': 'Aperçu',
      'global_seek.placeholder': 'Posez une question à travers les publications',
      'global_seek.advanced_search': 'Recherche avancée',
      'keyword.placeholder': 'Rechercher un mot-clé',
      'seek.suggestions': [
        'Donnez-moi un aperçu de ce jeu de données.',
        'Quelle est la couverture géographique de ce jeu de données ?',
        'Quels sont les variables/indicateurs du jeu de données ?',
        'Quelle est la couverture temporelle de ce jeu de données ?',
      ],
      'seek.cot.thought': 'Réflexion',
      'seek.cot.unknown': 'Inconnu',
      'seek.cot.tool_named': 'Outil : {0}',
      'seek.cot.result': 'Résultat',
      'seek.cot.result_named': 'Résultat : {0}',
      'seek.cot.thinking': 'Réflexion en cours...',
      'seek.cot.chain_of_thought': 'Chaîne de raisonnement',
      'seek.cot.steps': '{0} étapes',
      'seek.cot.status.starting': 'Lecture de votre question...',
      'seek.cot.status.analysing': 'Analyse des chiffres en cours...',
      'seek.cot.status.still_working': 'Toujours en cours : cela prend un peu plus de temps.',
      'seek.copy_response': 'Copier la réponse',
      'seek.copied': 'Copié',
      'seek.generative_ai': 'IA Générative',
      'seek.answer_derived_from_resources': 'La réponse provient des ressources suivantes :',
    }
  }
});